export function gabungRencana(rencana: string | null | undefined, tambahan: string | null | undefined): string {
  const awal = (rencana || "").replace(/\r\n/g, "\n");
  const teks = (tambahan || "").replace(/\r\n/g, "\n").trim();
  if (!teks) {
    return awal;
  }
  if (awal.includes(teks)) {
    return awal;
  }
  return awal.trim() ? `${awal.replace(/\s+$/, "")}\n${teks}` : teks;
}
